<app-header></app-header>

<div class="home-sales-section">
  <div>
    <div class="row ms-0 me-0">
      <div class="col-sm-12 col-lg-12 p-0">
        <div class="home-image">
          <div class="row content-bottom">
            <div class="col-md-12">
              <span class="mt-5"></span>
            </div>
            <div class="col-12 bg-light-grey text-center">
              <h1>Welcome Solar Homeowner</h1>
            </div>
            <span class="mt-5"></span>
            <div class="col-lg-1"></div>
            <div class="col-sm-12 col-md-6 col-lg-2">
              <button
                class="light-gray dashboard-icons"
                [routerLink]="['/life-events']"
              >
                <img
                  src="assets/calendar.png"
                  alt="schedule image"
                  class="icon"
                />
                <p>Life Events</p>
              </button>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-2">
              <button
                class="light-gray dashboard-icons"
                (click)="navigateToBilling()"
              >
                <img
                  src="assets/billing.png"
                  alt="billing image"
                  class="icon"
                />
                <p>Billing</p>
              </button>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-2">
              <button
                class="light-gray dashboard-icons"
                [routerLink]="['/forms']"
              >
                <img
                  src="assets/forms.png"
                  alt="production image"
                  class="icon"
                />
                <p>Forms</p>
              </button>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-2">
              <button
                class="light-gray dashboard-icons"
                [routerLink]="['/faq']"
              >
                <img src="assets/faq.png" alt="faq image" class="icon" />
                <p>FAQs</p>
              </button>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-2">
              <button
                class="light-gray dashboard-icons"
                [routerLink]="['/monitoring']"
              >
                <img
                  src="assets/production.png"
                  alt="production image"
                  class="icon"
                />
                <p>Monitoring</p>
              </button>
            </div>
            <span class="mt-5"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="form-select-option">
  <form [formGroup]="requestPhoneCall">
    <div class="container pt-2 pt-lg-5 pb-5">
      <div class="row pt-5 pb-5 text-center justify-content-center">
        <div class="col-12">
          <div
            class="question-section d-flex justify-content-center flex-column align-items-center"
          >
            <h1 class="mb-5">Other Questions or Help?</h1>
            <div class="contactus-button mt-4">
              <a [routerLink]="['/get-in-touch']">Contact Us</a>
            </div>
          </div>
        </div>
        @if(showMessage == false) {
          <div class="col-12 p-0 mt-3 d-flex flex-column align-items-center">
            <div
              class="accordion-main accordion accordion-flush"
              id="accordionFlushExample"
            >
              <div class="accordion-item" style="border-radius: 3px">
                <h2
                  class="accordion-header m-0"
                  id="flush-headingOne"
                  style="border-radius: 3px"
                >
                  <button
                    style="height: 52px; border-radius: 3px"
                    class="accordion-button form"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseOne"
                    aria-expanded="false"
                    aria-controls="flush-collapseOne"
                    id="toggleButton"
                    (click)="toggleIcons()"
                  >
                    Request a phone call
                    <i *ngIf="showPhoneIcon" class="phone fa-solid fa-phone"></i>
                    <i
                      *ngIf="!showPhoneIcon"
                      class="cancel fa-solid fa-xmark"
                    ></i>
                  </button>
                </h2>
                <div
                  id="flush-collapseOne"
                  class="form accordion-collapse collapse"
                  aria-labelledby="flush-headingOne"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div class="accordion-body">
                    <div class="main-form">
                      <div class="row mt-3 ms-0 me-0">
                        <!--
                        <div class="col-12 mt-2" *ngIf="
                        requestPhoneCall
                          ?.invalid">
                          <div class="alert-message">
                            <i class="fa-solid fa-circle-exclamation"></i>
                            There was a problem with your submission. Please review the fields below.
                          </div>
                        </div>
                        -->

                        <div class="col-12 mt-2">
                          <mat-label class="heading-name"> Name <span class="required-indicator"><i>(Required)</i></span> </mat-label>
                        </div>

                        <div class="col-6">
                          <span class="name_first">
                            <input
                              matInput
                              id="firstName"
                              formControlName="firstName"
                              required
                            />
                            <mat-label for="firstName" class="gform-field-label">
                              First
                            </mat-label>
                          </span>
                        </div>

                        <div class="col-6">
                          <span class="name_first">
                            <input
                              matInput
                              id="lastName"
                              formControlName="lastName"
                              required
                            />
                            <mat-label for="lastName" class="gform-field-label">
                              Last
                            </mat-label>
                          </span>
                        </div>

                        <mat-error
                          class="col-12 mt-2"
                          *ngIf="
                            requestPhoneCall.get('firstName')?.invalid &&
                            (requestPhoneCall.get('firstName')?.dirty ||
                              requestPhoneCall.get('firstName')?.touched)
                          "
                        >
                          <div class="alert-message">
                            <i class="fa-solid fa-circle-exclamation"></i>
                            This field is required. Please complete the First
                            Name.
                          </div>
                        </mat-error>

                        <mat-error
                          class="col-12 mt-2"
                          *ngIf="
                            requestPhoneCall.get('lastName')?.invalid &&
                            (requestPhoneCall.get('lastName')?.dirty ||
                              requestPhoneCall.get('lastName')?.touched)
                          "
                        >
                          <div class="alert-message">
                            <i class="fa-solid fa-circle-exclamation"></i>
                            This field is required. Please complete the Last Name.
                          </div>
                        </mat-error>

                        <div class="col-12 mt-2">
                          <mat-label class="heading-name"> Phone <span class="required-indicator"><i>(Required)</i></span> </mat-label>
                        </div>

                        <div class="col-12">
                          <span class="name_first">
                            <input
                              matInput
                              type="tel"
                              id="phoneNumber"
                              formControlName="phoneNumber"
                              required
                            />
                          </span>
                        </div>

                        <mat-error
                          class="col-12 mt-2"
                          *ngIf="
                            requestPhoneCall
                              .get('phoneNumber')
                              ?.hasError('pattern')
                          "
                        >
                          <div class="alert-message">
                            <i class="fa-solid fa-circle-exclamation"></i>
                            Phone format: (###) ###-####
                          </div>
                        </mat-error>

                        <mat-error
                          class="col-12 mt-2"
                          *ngIf="
                            requestPhoneCall.get('phoneNumber')?.invalid &&
                            (requestPhoneCall.get('phoneNumber')?.dirty ||
                              requestPhoneCall.get('phoneNumber')?.touched)
                          "
                        >
                          <div class="alert-message">
                            <i class="fa-solid fa-circle-exclamation"></i>
                            This field is required. Please complete the Phone
                            Number.
                          </div>
                        </mat-error>

                        <div class="col-12 mt-4">
                          <mat-label class="heading-name" for="accountNumber"
                            >Account</mat-label
                          >
                        </div>
                        <div class="col-12">
                          <span class="name_first">
                            <input
                              matInput
                              type="text"
                              id="accountNumber"
                              formControlName="accountNumber"
                            />
                          </span>
                        </div>

                        <div class="col-12 mt-3">
                          <mat-label class="heading-name">
                            When do you want a callback? <span class="required-indicator"><i>(Required)</i></span>
                          </mat-label>
                        </div>

                        <div class="col-12">
                          <mat-radio-group
                            formControlName="requestCall"
                            required="required"
                          >
                            <mat-radio-button
                              value="now"
                              [disabled]="isCallNowDisabled"
                              ><span class="label-name"
                                >Request Call Now</span
                              ></mat-radio-button
                            >
                            <br />
                            <mat-radio-button value="schedule"
                              value="schedule"
                              ><span class="label-name"
                                >Schedule Phone Call</span
                              ></mat-radio-button
                            >
                          </mat-radio-group>
                        </div>
                        <div class="col-12 mt-2">
                          <mat-error
                            *ngIf="
                              requestPhoneCall.get('requestCall')?.invalid &&
                              (requestPhoneCall.get('requestCall')?.dirty ||
                                requestPhoneCall.get('requestCall')?.touched)
                            "
                          >
                            <div class="alert-message">
                              <i class="fa-solid fa-circle-exclamation"></i>
                              This field is required. Please select.
                            </div>
                          </mat-error>
                        </div>

                        <div
                          class="col-12"
                          id="scheduleCallSection"
                          *ngIf="
                            requestPhoneCall.get('requestCall')?.value ===
                            'schedule'
                          "
                        >
                          <div class="row">
                            <div class="col-6 mt-4 mb-3">
                              <span class="name_first">
                                <!-- Old Code -->
                                <!--
                                <mat-label class="heading-name" for="callDate"> Date </mat-label>
                                <input type="date" matInput formControlName="callDate" id="callDate" placeholder="mm/dd/yyyy" [min]="minDate" [max]="maxDate" (change)="onDateChange($event)" required />
                                -->

                                <!-- New Code -->
                                <mat-label class="heading-name" for="callDate">
                                  Date
                                </mat-label>
                                <mat-form-field class="transparent-form-field">
                                  <input
                                    matInput
                                    [matDatepickerFilter]="dateFilter"
                                    [matDatepicker]="picker"
                                    formControlName="callDate"
                                    placeholder="mm/dd/yyyy"
                                  />
                                  <mat-datepicker-toggle
                                    matSuffix
                                    [for]="picker"
                                  ></mat-datepicker-toggle>
                                  <mat-datepicker #picker></mat-datepicker>
                                </mat-form-field>
                              </span>
                            </div>
                            <div class="col-6 mt-4 mb-3">
                              <mat-label class="heading-name" for="callTime">
                                Time
                              </mat-label>
                              <select
                                class="form-select"
                                id="callTime"
                                formControlName="callTime"
                                required
                              >
                                <option
                                  *ngFor="let option of timeOptions"
                                  [value]="option.value"
                                >
                                  {{ option.viewValue }}
                                </option>
                              </select>
                              <div
                                class="gfield_description"
                                id="gfield_description_6_9"
                              >
                                Please allow a 30-minute window for all scheduled
                                callbacks
                              </div>
                            </div>
                          </div>
                        </div>

                        <mat-error
                          class="col-12 mt-2"
                          *ngIf="
                            requestPhoneCall.get('callDate')?.invalid &&
                            (requestPhoneCall.get('callDate')?.dirty ||
                              requestPhoneCall.get('callDate')?.touched)
                          "
                        >
                          <div class="alert-message">
                            <i class="fa-solid fa-circle-exclamation"></i>
                            This field is required. Please select the Date.
                          </div>
                        </mat-error>

                        <mat-error
                          class="col-12 mt-2"
                          *ngIf="
                            requestPhoneCall.get('callTime')?.invalid &&
                            (requestPhoneCall.get('callTime')?.dirty ||
                              requestPhoneCall.get('callTime')?.touched)
                          "
                        >
                          <div class="alert-message">
                            <i class="fa-solid fa-circle-exclamation"></i>
                            This field is required. Please select the Time.
                          </div>
                        </mat-error>

                        <div class="col-12 mt-4">
                          <mat-label class="heading-name" for="reason"
                            >Reason for request <span class="required-indicator"><i>(Required)</i></span></mat-label
                          >
                        </div>
                        <div class="col-12 mt-3">
                          <select
                            class="form-select"
                            id="reason"
                            formControlName="reason"
                            required
                          >
                            <option
                              *ngFor="let option of reasonOptions"
                              [value]="option.value"
                            >
                              {{ option.viewValue }}
                            </option>
                          </select>
                          <br />
                          <mat-error
                            class="col-12"
                            *ngIf="
                              requestPhoneCall.get('reason')?.invalid &&
                              (requestPhoneCall.get('reason')?.dirty ||
                                requestPhoneCall.get('reason')?.touched)
                            "
                          >
                            <div class="alert-message">
                              <i class="fa-solid fa-circle-exclamation"></i>
                              This field is required. Please select the reason.
                            </div>
                          </mat-error>
                        </div>

                        <div class="col-12 mt-4">
                          <mat-label class="heading-name" for="language">
                            Language to be used on contact
                          </mat-label>
                        </div>
                        <div class="col-12 mt-2">
                          <select
                            class="form-select"
                            id="language"
                            formControlName="language"
                          >
                            <option
                              *ngFor="let option of languageOptions"
                              [value]="option.value"
                            >
                              {{ option.viewValue }}
                            </option>
                          </select>
                        </div>
                        <div class="col-12 mt-4">
                          <button
                            type="button"
                            class="submit-button"
                            style="margin: auto"
                            data-conditional-logic="visible"
                            (click)="submitForm()"
                          >
                            <span>Submit</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        @else{
          <div>
            <h4 style="text-align: center; color: white; padding-top: 50px">
              {{ message }}
            </h4>
            <br /><br />
          </div>
        }

        @if(loading == true) {
          <div class="overlay">
            <mat-spinner [diameter]="40" color="primary"></mat-spinner>
          </div>
        }
        <div class="request-form" *ngIf="!showMessage">
          <div class="select-option">
            <div class="container">
              <div class="row"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<app-footer></app-footer>
